import { makeRequest } from './https';
import {
  CreateObjectiveRequest,
  LinkObjectiveTaskRequest,
  Objective,
  ObjectiveTaskLink,
  UpdateObjectiveRequest,
} from '../types/objective.type';

interface ObjectivesResponse {
  data: Objective[];
}

export const getObjectives = () =>
  makeRequest({ url: '/objectives', method: 'get' }) as Promise<ObjectivesResponse>;

export const getObjective = (objectiveId: string) =>
  makeRequest({ url: `/objectives/${objectiveId}`, method: 'get' }) as Promise<Objective>;

export const createObjective = (body: CreateObjectiveRequest) =>
  makeRequest({ url: '/objectives', method: 'post', data: body }) as Promise<Objective>;

export const updateObjective = (objectiveId: string, body: UpdateObjectiveRequest) =>
  makeRequest({ url: `/objectives/${objectiveId}`, method: 'patch', data: body }) as Promise<Objective>;

export const deleteObjective = (objectiveId: string) =>
  makeRequest({ url: `/objectives/${objectiveId}`, method: 'delete' }) as Promise<{ message: string }>;

export const linkObjectiveTask = (objectiveId: string, body: LinkObjectiveTaskRequest) =>
  makeRequest({ url: `/objectives/${objectiveId}/tasks`, method: 'post', data: body }) as Promise<{ message: string }>;

export const unlinkObjectiveTask = (
  objectiveId: string,
  ownerId: string,
  taskListId: string,
  googleTaskId: string,
) =>
  makeRequest({
    url: `/objectives/${objectiveId}/tasks/${ownerId}/${taskListId}/${googleTaskId}`,
    method: 'delete',
  }) as Promise<{ message: string }>;

export const saveObjectiveTaskLinks = (objectiveId: string, links: ObjectiveTaskLink[]) =>
  makeRequest({
    url: `/objectives/${objectiveId}/task-links`,
    method: 'put',
    data: { links },
  }) as Promise<{ message: string }>;
